import React from 'react'
import { Route, Routes } from 'react-router-dom'
import { lazy as loadable } from '@loadable/component'

import { wrapSuspenseComponent } from '@newComponents/SuspenseWrapper'

import { DocsSection } from '../shared/DocsSection'

const Overview = wrapSuspenseComponent(loadable(() => import('./Overview')))
const SignIn = wrapSuspenseComponent(loadable(() => import('./SignIn')))
const Profile = wrapSuspenseComponent(loadable(() => import('./Profile')))
const Joining = wrapSuspenseComponent(loadable(() => import('./Joining')))
const Notifications = wrapSuspenseComponent(
  loadable(() => import('./Notifications'))
)
const Security = wrapSuspenseComponent(loadable(() => import('./Security')))
const Calendar = wrapSuspenseComponent(loadable(() => import('./Calendar')))
const Embeds = wrapSuspenseComponent(loadable(() => import('./Embeds')))

const AccountSection = () => (
  <DocsSection section='account'>
    <Routes>
      <Route index element={<Overview />} />
      <Route path='overview' element={<Overview />} />
      <Route path='sign-in' element={<SignIn />} />
      <Route path='profile' element={<Profile />} />
      <Route path='joining' element={<Joining />} />
      <Route path='notifications' element={<Notifications />} />
      <Route path='security' element={<Security />} />
      <Route path='calendar' element={<Calendar />} />
      <Route path='embeds' element={<Embeds />} />
    </Routes>
  </DocsSection>
)

export default AccountSection
